<template>
  <v-dialog v-model="show" max-width="440">
    <v-card v-if="deposit">
      <v-card-title class="d-flex align-center justify-space-between">
        <span>{{ formatCurrency(deposit.amount, restaurantCurrency) }}</span>
        <v-chip small :color="statusMeta.color" text-color="white">
          {{ statusMeta.labelKey ? $t(statusMeta.labelKey) : "" }}
        </v-chip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <div class="detail-row">
          <span>{{ $t("finance_proof_of_payment") }}</span>
          <strong v-if="deposit.proof" class="proof-link">
            <v-icon size="14" color="primary">mdi-paperclip</v-icon>
            {{ deposit.proof }}
          </strong>
          <strong v-else class="grey--text">{{ $t("finance_not_attached") }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_bank_transaction") }}</span>
          <strong>{{ deposit.bankTransaction || "—" }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_recorded_by") }}</span>
          <strong>{{ deposit.recordedBy || "—" }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_note") }}</span>
          <strong>{{ deposit.note || "—" }}</strong>
        </div>
      </v-card-text>
      <template v-if="deposit.status === 'pending'">
        <v-divider />
        <v-card-actions>
          <v-btn text color="error" @click="$emit('delete', deposit)">{{ $t("finance_delete") }}</v-btn>
          <v-spacer />
          <v-btn text @click="$emit('edit', deposit)">{{ $t("finance_edit") }}</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { DEPOSIT_STATUS_META, formatCurrency } from "../constants";

export default {
  name: "DepositDetailDialog",

  props: {
    value: { type: Boolean, default: false },
    deposit: { type: Object, default: null },
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    statusMeta() {
      return (this.deposit && DEPOSIT_STATUS_META[this.deposit.status]) || { labelKey: "", color: "grey" };
    },
  },

  methods: { formatCurrency },
};
</script>

<style scoped>
.detail-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.6);
  padding: 4px 0;
}

.detail-row strong {
  color: rgba(0, 0, 0, 0.87);
  text-align: right;
}

.proof-link {
  color: #1976d2 !important;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
</style>
